import React from "react";
import Header from "../../components/appLayout/header";
import { useTranslation } from "../../hooks/useTranslation";

export default function CookiesPolicy() {
  const { t } = useTranslation();
  const lastUpdated = "15-10-2025";

  return (
    <>
      <Header />
      <main className="privacy-page mt-5" aria-labelledby="cookies-title">
        <div className="container">
          <header className="privacy-header">
            <h1 id="cookies-title">{t('cookiesTitle')}</h1>
            <p className="last-updated">
              {t('cookiesLastUpdated')} <strong>{lastUpdated}</strong>
            </p>
            <p className="lead">
              {t('cookiesLead')}
            </p>
          </header>

          <section className="policy-section" id="what-are-cookies">
            <h2>{t('cookiesWhatAre')}</h2>
            <p>
              {t('cookiesWhatAreText')}
            </p>
          </section>

          <section className="policy-section" id="types-of-cookies">
            <h2>{t('cookiesTypes')}</h2>
            <ul>
              <li>
                <strong>{t('cookiesEssential')}</strong> {t('cookiesEssentialText')}
              </li>
              <li>
                <strong>{t('cookiesAnalytics')}</strong> {t('cookiesAnalyticsText')}
              </li>
              <li>
                <strong>{t('cookiesFunctional')}</strong> {t('cookiesFunctionalText')}
              </li>
              <li>
                <strong>{t('cookiesMarketing')}</strong> {t('cookiesMarketingText')}
              </li>
            </ul>
          </section>

          <section className="policy-section" id="how-we-use-cookies">
            <h2>{t('cookiesHowWeUse')}</h2>
            <ul>
              <li>{t('cookiesUse1')}</li>
              <li>{t('cookiesUse2')}</li>
              <li>{t('cookiesUse3')}</li>
            </ul>
          </section>

          <section className="policy-section" id="managing-cookies">
            <h2>{t('cookiesManaging')}</h2>
            <p>
              {t('cookiesManagingText')}
            </p>
            <p>{t('cookiesManagingDetails')}</p>
            <ul>
              <li>Google Analytics Opt-Out</li>
              <li>All About Cookies</li>
            </ul>
          </section>

          <section className="policy-section" id="updates">
            <h2>{t('cookiesUpdates')}</h2>
            <p>
              {t('cookiesUpdatesText')}
            </p>
          </section>
        </div>
      </main>
    </>
  );
}
